import Vue from "vue";
import App from "./App.vue";

// Disable Vue chattyness
Vue.config.productionTip = false;

// Setup vue router
import VueRouter from "vue-router";
Vue.use(VueRouter);
import initializeRouter from "./router";

// Import the store
import store from "./store";

// Setup the sidebar menu
import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
Vue.use(VueSidebarMenu);

// Setup toast
import ToastService from "primevue/toastservice";
Vue.use(ToastService);

//primevue
import PrimeVue from "primevue/config";
Vue.use(PrimeVue);

//import element-ui
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";
Vue.use(ElementUI, { locale });

//Bootstrap
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import GenericTable from "generictable-v2";
Vue.use(GenericTable);

// Import $tera / @iebh/Tera-fy global service
// NOTE: See bottom of file inside main async() init loop for when TeraFy actually boots
import TeraFy from "@iebh/tera-fy/dist/terafy.es2019.js"; // FIX: Use annoyingly old and specific version as Babel struggles with ESNEXT class imports
import TerafyVue from "@iebh/tera-fy/dist/plugin.vue2.es2019.js";
import { defaultProjectState } from "./defaultProjectState";
import { checkAllKeysExist } from "./helpers/objectUtils";
import { updateTable } from "./helpers/tableUpdate.js";

let terafy = new TeraFy()
	.set("devMode", process.env.VUE_APP_TERAFY_DEV == 1)
	.setIfDev("verbosity", process.env.VUE_APP_TERAFY_VERBOSITY || 1)
	.setIfDev("siteUrl", process.env.VUE_APP_TERAFY_URL)
	.use(TerafyVue); // Add the Vue plugin

// Register all Input/Base Components Globally {{{
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

const requireComponent = require.context(
	// The relative path of the components folder
	"./components",
	// Whether or not to look in subfolders
	false,
	// The regular expression used to match base component filenames
	/(Input|Base)[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
	// Get component config
	const componentConfig = requireComponent(fileName);

	// Get PascalCase name of component
	const componentName = upperFirst(
		camelCase(
			// Gets the file name regardless of folder depth
			fileName
				.split("/")
				.pop()
				.replace(/\.\w+$/, "")
		)
	);

	// Register component globally
	Vue.component(
		componentName,
		// Look for the component options on `.default`, which will
		// exist if the component was exported with `export default`,
		// otherwise fall back to module's root.
		componentConfig.default || componentConfig
	);
});
// }}}

// Text fields across the app only write to $tera.project on blur (not per
// keystroke, to avoid flooding the realtime sync). Force a blur before the
// page unloads so a field that's still focused gets its pending edit flushed
// instead of silently discarded on refresh/close.
window.addEventListener("beforeunload", () => {
	if (
		document.activeElement &&
		typeof document.activeElement.blur === "function"
	) {
		document.activeElement.blur();
	}
});

(async () => {
								const router = await initializeRouter();
	const app = new Vue({
		router,
		store,
		render: h => h(App)
	});

	// Boot teraFy + require project + pull & subscribe to project data
	await terafy.init({
		app, // Provide app to bind against
		Vue // Provide the vue version to use
	});

	// OLD
	// await terafy.setProjectStateDefaults(defaultProjectState);
	// Refresh state so it is available after being set
	// CF: This would be the fix but isn't functional in TERA-fy grr
	// await terafy.setProjectStateRefresh();

	// NEW - To fix error of state not updating remotely after loading first time
	// Check that terafy.project has all keys/subkeys in defaultProjectState

	//Update table array
	//Only for ReviewWizard now (need add a similar one for TrialWizard if need)
	updateTable(
		defaultProjectState.planTable,
		terafy.project,
		"ReviewWizard",
		"1.0.1"
	);

	const allKeysPresent = checkAllKeysExist(terafy.project, defaultProjectState);
	if (!allKeysPresent) {
		console.warn("Detected missing keys, setting defaults and refreshing");
		/*if (terafy.project) {
			terafy.project.planTable = undefined;
			if (terafy.project.TrialWizard) {
				terafy.project.TrialWizard.trialplanTable = undefined;
			}
		}*/
		await terafy.setProjectStateDefaults(defaultProjectState);
		// FIXME: This page refresh is required
		// look above for better solution
		window.location.reload();
	}

	app.$mount("#app");
})();
